<script lang="ts">
  import type { PlanningPreviewRow } from "../../../../../../_shared/_logic/table-contract"
  const { row }: { row: PlanningPreviewRow } = $props()
</script>
<span class="readonly-cell"
  >{row.estimatedDurationValue ? `${row.estimatedDurationValue} Min.` : "—"}</span
>
<style lang="less">
  .readonly-cell {
    color: var(--text-invers-100);
    font-weight: 800;
    white-space: nowrap;
  }
</style>
